import React from "react";
import { useTranslation } from "ceco-polyglot";
import "./MessageSuccess.scss";

export default function MessageSuccess(props) {
  const { idSac } = props;
  const t = useTranslation();
  return (
    <div className="message-success">
      <p>{t("MessageSuccess.thanks")}</p>
      <p>{t("MessageSuccess.sent")}</p>
        {!!idSac ?
            (<p>
        {t("MessageSuccess.request")}: {idSac}
      </p>) :
        <p>Recibirá un correo con la información</p>}
    </div>
  );
}
